import { render, staticRenderFns } from "./teamRanking.vue?vue&type=template&id=45d010c6&scoped=true&"
import script from "./teamRanking.vue?vue&type=script&lang=js&"
export * from "./teamRanking.vue?vue&type=script&lang=js&"
import style0 from "./teamRanking.vue?vue&type=style&index=0&id=45d010c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d010c6",
  null
  
)

export default component.exports